import { initCanvas } from './BackgroundAnimation/index.js'
import { type Style } from 'inlines'
import { useEffect, useRef } from 'react'

export const Background = ({
  motion,
  type,
  debug = false,
  primaryColor,
  secondaryColor,
}: {
  type: 'onboarding' | 'voting' | 'cart' | 'payment'
  motion?: number
  style?: Style
  debug?: boolean
  primaryColor?: string
  secondaryColor?: string
}) => {
  const ref = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    if (ref.current) {
      const root = getComputedStyle(document.documentElement)
      return initCanvas(ref.current, type, {
        motion: motion,
        debug: debug,
        onFail: () => {
          if (ref.current) {
            const isMobile = window.innerWidth < 561
            ref.current.style.backgroundImage = isMobile
              ? `url(https://files-baseddb-saulx-esc2026-production-en-e-e-ko51x0.based.dev/cdn-cgi/image/w=767/230q7bb/8f78d051-d70d-4935-9ab8-0bc079c85281-8fe9c5f9-d3be-4ce5-81c5-376726e8607b-f2c9c243-94ca-499f-87f8-9be314b2beb8.webp)`
              : `url(https://files-baseddb-saulx-esc2026-production-en-e-e-ko51x0.based.dev/cdn-cgi/image/w=1480/22avg0x/1daa548c-86b9-4652-b720-c77cb5f8a272-d99aceb1-50d0-4daa-83ab-76157b26cba2-85d00adc-c14c-48d9-a620-ae3d4e6ed4e7.webp)`
            ref.current.style.backgroundSize = 'cover'
            ref.current.style.backgroundPosition = 'center'
            ref.current.style.width = '100vw'
            ref.current.style.minHeight = '100vh'
            ref.current.style.top = '0px'
            ref.current.style.bottom = '0px'
            ref.current.style.transform = 'translateY(0px)'
          }
        },
        primaryColor:
          primaryColor ?? root.getPropertyValue('--color-bg-anim-one').trim(),
        secondaryColor:
          secondaryColor ?? root.getPropertyValue('--color-bg-anim-two').trim(),
      })
    }
  }, [type, primaryColor, secondaryColor])

  return (
    <canvas
      ref={ref}
      style={{
        position: 'fixed',
        transform: 'translateY(64px)',
        zIndex: -1,
        inset: 0,
        top: 64,
        bottom: 'calc(100vh - env(safe-area-inset-bottom)',
      }}
    />
  )
}
